declare global {
    interface Window {
        language: string,
        translations: Array<string>,
        Alpine: any;
        Pinia: any;
    }
}

// import css
import '~/css/teammasters.css'

// import icons
import '~/js/assets/icons.js'

// alpine
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse';
import heroVideo from '~/js/alpine/hero-video'
import fieldChecklist from '~/js/offer-generator/checklist'
import offerPreviewToolbar from '~/js/offer-generator/preview-toolbar'

window.Alpine = Alpine
Alpine.plugin(focus)
Alpine.plugin(collapse)

const navigation = () => ({
    activeSubNav: '',
    activeSubSubNav: '',
    screenWidth: 0,
    showLanguageNavigation: false,
    showMobileNavigation: false,
    timeout: null as number | null,
    
    debounce(func: () => void, wait: number, breakpoint: number|null = null) {
        if (breakpoint && window.innerWidth < breakpoint) {
            return
        }
        
        const later = () => {
            this.timeout = null
            func()
        }

        if (this.timeout) {
            clearTimeout(this.timeout)
        }

        this.timeout = window.setTimeout(later, wait) as unknown as number
    },
    
    setBack(level) {
        switch (level) {
                case 0:
                    this.activeSubNav = ''
                    this.activeSubSubNav = ''
                    this.showMobileNavigation = false
                    break
                case 1:
                    this.activeSubNav = ''
                    break
                case 2:
                    this.activeSubSubNav = ''
                    break
        }
    },
    
    getShowSubnavs(level, title = null) {
        let check = false
        
        switch (level) {
                case 1:
                    check = this.activeSubNav == title
                    break
                case 2:
                    check = this.activeSubSubNav == title
                    break
        }
        
        return check
    },

    toggleMobileNavigation() {
        this.showMobileNavigation = !this.showMobileNavigation

        if (!this.showLanguageNavigation) {
            this.activeSubNav = ''
            this.activeSubSubNav = ''
        }

        if (this.showMobileNavigation) {
            document.body.classList.add('overflow-hidden')
        } else {
            document.body.classList.remove('overflow-hidden')
        }
    },

    init() {
        this.screenWidth = window.innerWidth
        
        window.addEventListener('resize', () => {
            this.screenWidth = window.innerWidth
        })
    }
})

const form = () => ({
    pages: null as NodeListOf<Element> | null,
    currentPage: 0,
    totalPages: 0,

    onHandleNext() {
        this.setActive()
    },
    setActive() {
        if (!this.pages) return

        setTimeout(() => { 
            this.setCurrentPage()
            this.setHidePrevNextButtons()

            if (this.currentPage < this.totalPages - 1) {
                this.setVisibleSteps()
            }

            this.scrollCurrentStepIntoView()
        },0)
    },
    setCurrentPage() {
        if (!this.pages) return

        let index = 0
        this.pages.forEach((page:Element) => {
            if (!page.hasAttribute('data-fui-page-hidden')) this.currentPage = index
            index++
        })
    },
    setVisibleSteps() {
        if (!this.pages) return

        let index = 0
        this.pages.forEach((page:Element) => {
            if (index < this.currentPage) {
                page.removeAttribute('data-fui-page-hidden')
            }

            index++
        })
    },
    setHidePrevNextButtons() {
        if (!this.pages) return

        let index = 0
        this.pages.forEach((page:Element) => {
            if (index != this.currentPage) {
                page.querySelector('.fui-prev')?.classList?.add('!hidden')
                page.querySelector('.fui-next')?.classList?.add('!hidden')
            }

            if (index == this.currentPage) {
                page.querySelector('.fui-prev')?.classList?.remove('!hidden')
                page.querySelector('.fui-next')?.classList?.remove('!hidden')
            }

            index++
        })
    },

    scrollCurrentStepIntoView() {
        if (this.currentPage > 0) {
            const element = this.pages?.[this.currentPage]
            
            if (element) {
                const top = element.getBoundingClientRect().top + window.scrollY - 100;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        }
    },
    init() {
        this.pages = document.querySelectorAll('[data-fui-page]')
        this.totalPages = this.pages?.length ?? 0
        const form = document.querySelector('.fui-form')

        if (!form) return

        this.setActive()

        form.addEventListener('onAfterFormieSubmit', () => {
            this.setActive()

            setTimeout(() => {
                this.scrollCurrentStepIntoView()
            }, 200)
        })

        form.querySelectorAll('[data-fui-page-tab]')?.forEach((tab:Element) => {
            tab.addEventListener('click', evt => {
                evt.preventDefault()
            })
        })
    }
})

Alpine.data('navigation', navigation)
Alpine.data('form', form)
Alpine.data('heroVideo', heroVideo)
Alpine.data('fieldChecklist', fieldChecklist)
Alpine.data('offerPreviewToolbar', offerPreviewToolbar)
Alpine.start()

document.addEventListener("DOMContentLoaded", function () {
    if (window.location.hash) {
        setTimeout(() => {
            const targetId = window.location.hash.substring(1)
            const targetElement = document.getElementById(targetId)
    
            if (targetElement) {
                const offset = 120
                const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY
                window.scrollTo({
                    top: elementPosition - offset,
                    behavior: "smooth"
                })
            }
        }, 1000)
    }
})

// Open the native date picker when clicking anywhere in a date input, not just its icon
document.addEventListener('click', (evt) => {
    const input = evt.target

    if (input instanceof HTMLInputElement && input.type === 'date' && 'showPicker' in input) {
        try {
            input.showPicker()
        } catch {
            // NotAllowedError or InvalidStateError (e.g. picker already open): native behaviour still applies
        }
    }
})

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR active')
    })
}